(function () {
    'use strict';
    realmCommerceApp.factory('customerService', CustomerService);

    /*@ngInject*/
    function CustomerService(apiService, customerPreview, customer, customerPurchasedProducts) {
        var service = {
            customerPreview: customerPreview,
            customer: customer,
            getCustomerPreview: getCustomerPreview,
            getCustomer: getCustomer,
            removeAddress: removeAddress,
            setPrimaryAddress: setPrimaryAddress,
            updateCustomerModel: updateCustomerModel,
            saveAddress: saveAddress,
            isProductAlreadyPurchased: isProductAlreadyPurchased,
        };
        return service;

        function getCustomerPreview() {
            return service.customerPreview;
        }

        function getCustomer() {
            return service.customer;
        }

        function removeAddress(addressId) {
            return apiService.removeCustomerAddress(addressId)
        }

        function setPrimaryAddress(addressId) {
            return apiService.setPrimaryAddress(addressId);
        }

        function saveAddress(data, id) {
            return apiService.saveCustomerAddress(data, id);
        }

        function updateCustomerModel(data) {
            if (typeof data.customer != 'undefined') {
                service.customer = data.customer;
            }
            if (typeof data.customerPreview != 'undefined') {
                service.customerPreview = data.customerPreview;
            }
        }

        function isProductAlreadyPurchased(entityId) {
            if(customerPurchasedProducts && customerPurchasedProducts.orderedProducts){
                return  customerPurchasedProducts.orderedProducts.find(order => order.entity_id == entityId) !== undefined;
            }
            return false;
        }
    }
})();


// WEBPACK FOOTER //
// ./static/js/app/services/customer.service.js